import { Component } from '@angular/core';
import { AuthService } from './auth.service';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./shared.css']
})
export class SignupComponent {
  role = 'doctor';
  name = '';
  email = '';
  phone = '';
  password = '';
  confirmPassword = '';
  message = '';
  error = '';
  verifyLink = '';
  constructor(private auth: AuthService) {}
  signup(): void {
    this.error = '';
    this.message = '';
    this.verifyLink = '';
    if (this.password !== this.confirmPassword) {
      this.error = 'Passwords do not match';
      return;
    }
    this.auth.signup({ name: this.name, email: this.email, phone: this.phone, password: this.password, role: this.role }).subscribe({
      next: (res: any) => {
        this.message = res?.message || 'Signup successful';
        this.verifyLink = res?.verify_link || '';
      },
      error: (err) => this.error = err?.error?.error || 'Signup failed'
    });
  }
}
